import { useEffect } from "react";

import { useState } from "react";
import { PageLoading } from "../../../components/page_loading";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import FormHelperText from "@mui/joy/FormHelperText";

export const HttpApiComponent = (props: {
  loading: boolean;
  deploymentId: string;
  httpApiStackParamsJson: string | null;
  httpApiStackStatus: string | null;
}) => {
  const { loading, httpApiStackParamsJson, httpApiStackStatus } = props;

  const [fullDomainName, setFullDomainName] = useState<string>("");
  const [backendApiHostname, setBackendApiHostname] = useState<string>("");
  const [genericCertificateArn, setGenericCertificateArn] =
    useState<string>("");
  const [logRetentionDays, setLogRetentionDays] = useState<string>("");

  useEffect(() => {
    if (httpApiStackParamsJson) {
      const params = JSON.parse(httpApiStackParamsJson);
      setFullDomainName(params.FullDomainName || "");
      setBackendApiHostname(params.BackendApiHostname || "");
      setGenericCertificateArn(params.GenericCertificateArn || "");
      setLogRetentionDays(params.LogRetentionDays || "");
    }
  }, [httpApiStackParamsJson]);

  return (
    <>
      <PageLoading loading={loading} />
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={12}>
          <Typography level="body-sm" sx={{ py: 1 }}>
            CloudFormation stack status: {httpApiStackStatus || "Not deployed"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Full Domain Name</FormLabel>
            <Input
              disabled={true}
              value={fullDomainName}
              onChange={(event) => {
                setFullDomainName(event.target.value);
              }}
            />
            <FormHelperText>The full domain name of deployment.</FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Backend API Hostname</FormLabel>
            <Input
              disabled={true}
              value={backendApiHostname}
              onChange={(event) => {
                setBackendApiHostname(event.target.value);
              }}
            />
            <FormHelperText>
              The backend API hostname of deployment.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>SSL Certificate ARN</FormLabel>
            <Input
              disabled={true}
              value={genericCertificateArn}
              onChange={(event) => {
                setGenericCertificateArn(event.target.value);
              }}
            />
            <FormHelperText>
              The generic SSL certificate ARN of the deployment.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Log Retention Days</FormLabel>
            <Input
              disabled={true}
              value={logRetentionDays}
              onChange={(event) => {
                setLogRetentionDays(event.target.value);
              }}
            />
            <FormHelperText>
              The log retention days of the deployment.
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
